/* lystia-favorites-page.js - сторінка «Улюблене» (T-E5-09, parity/favorites.md; прототип cart.js favContent/confirmClearFav).
   Підключення: <script src="{{ 'lystia-favorites-page.js' | asset_url }}" defer> (sections/main-favorites.liquid) після lystia-core/favorites/overlay/toast.
   <lystia-favorites>: список handle з window.LystiaFavorites (localStorage `lystia:fav`, A-003); картки - Section Rendering API:
   GET /products/<handle>?section_id=<data-section-file> повертає <div data-fav-card> (режим «фрагмент» тієї ж секції).
   Стани (data-state): loading (лише H1) · full (крихти D, H1 + «N чаїв», «Очистити список», сітка) · empty.
   Зняття ♥ на сторінці -> картка зникає (fav:change active=false); тост «Прибрано з улюбленого» показує сама картка (lystia-product-card.js);
   undo не робимо, термін 30 днів (A-079, Q-FAVUX). Недоступні/видалені товари пропускаються мовчки (Q-FAVUX(3) OPEN).
   Очищення: confirm-оверлей `confirm-clear-fav` (snippets/overlay) -> LystiaFavorites.clear() + тост «Список очищено».
   Тексти беруться з data-атрибутів хоста (locales у Liquid), у файлі їх немає. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('lystia-favorites')) return;

  var OVERLAY = 'confirm-clear-fav';

  function plural(n) {
    try { return new Intl.PluralRules('uk').select(n); } catch (e) { return 'many'; }
  }

  class LystiaFavorites extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.cards = new Map();   /* handle -> елемент картки (або null, якщо недоступна) */
      this.pending = new Map(); /* handle -> Promise */
      this.fullEl = this.querySelector('[data-fav-full]');
      this.emptyEl = this.querySelector('[data-fav-empty]');
      this.fullOnly = this.querySelectorAll('[data-fav-full-only]');
      this.gridEl = this.querySelector('[data-fav-grid]');
      this.countEl = this.querySelector('[data-fav-count]');
      this.sectionFile = this.getAttribute('data-section-file');
      this.baseUrl = this.getAttribute('data-products-url') || '/products/';

      this.onFav = function (e) {
        var d = (e && e.detail) || {};
        if (d.reason === 'clear') return; /* пакетне очищення оновимо один раз після clear() */
        self.refresh();
      };
      this.onStorage = function (e) { if (e.key === 'lystia:fav' || e.key === null) self.refresh(); };
      this.onClick = function (e) {
        var ok = e.target.closest && e.target.closest('[data-fav-clear-confirm]');
        if (ok) { e.preventDefault(); self.clear(); }
      };
      this.onOverlay = function (e) {
        var d = (e && e.detail) || {};
        if (d.name !== OVERLAY) return;
        var p = d.panel && d.panel.querySelector('[data-confirm-text]');
        if (p) p.textContent = self.confirmText();
      };
      document.addEventListener('fav:change', this.onFav);
      window.addEventListener('storage', this.onStorage);
      document.addEventListener('click', this.onClick);
      document.addEventListener('lystia:overlay-open', this.onOverlay);
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('fav:change', this.onFav);
      window.removeEventListener('storage', this.onStorage);
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('lystia:overlay-open', this.onOverlay);
    }

    api() { return window.LystiaFavorites; }

    /* «N чаїв» з форм locales (Intl.PluralRules uk -> one/few/many) */
    countText(n) {
      var f = plural(n);
      var tpl = this.getAttribute('data-count-' + (f === 'one' || f === 'few' ? f : 'many')) || '';
      return tpl.replace('__N__', String(n));
    }

    /* Текст підтвердження: n>1 -> «Усі N чаїв» + суфікс; n=1 -> «Чай» + суфікс (дослівно, Q-FAVUX(2) OPEN). n = кількість ключів у сховищі */
    confirmText() {
      var api = this.api();
      var n = api ? api.count() : 0;
      var suffix = this.getAttribute('data-confirm-suffix') || '';
      if (n > 1) return (this.getAttribute('data-confirm-many') || '').replace('__NP__', this.countText(n)) + suffix;
      return this.getAttribute('data-confirm-one') || '';
    }

    fetchCard(handle) {
      if (this.pending.has(handle)) return this.pending.get(handle);
      var url = this.baseUrl + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(this.sectionFile);
      var p = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .then(function (html) {
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          return tpl.content.querySelector('[data-fav-card]');
        })
        .catch(function () { return null; });
      this.pending.set(handle, p);
      return p;
    }

    /* Звести DOM зі списком handle: прибрати зайві картки, дозавантажити відсутні, відмалювати стан. */
    refresh() {
      var self = this;
      var api = this.api();
      var handles = api ? api.list() : [];
      var token = (this.token = (this.token || 0) + 1);
      var need = handles.filter(function (h) { return !self.cards.has(h); });
      if (!need.length) { this.render(handles); return; }
      Promise.all(need.map(function (h) {
        return self.fetchCard(h).then(function (el) { self.cards.set(h, el); self.pending.delete(h); });
      })).then(function () { if (token === self.token) self.render(handles); });
    }

    render(handles) {
      var self = this;
      var api = this.api();
      var live = api ? api.list() : handles;
      var shown = live.filter(function (h) { return self.cards.get(h); });
      /* прибрати з пам'яті те, чого вже нема у списку */
      Array.from(this.cards.keys()).forEach(function (h) { if (live.indexOf(h) < 0) self.cards.delete(h); });

      var nodes = [];
      shown.forEach(function (h) {
        var cell = self.gridEl.querySelector(':scope > [data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
        if (!cell) {
          cell = self.cards.get(h).cloneNode(true);
          cell.removeAttribute('data-fav-card');
        }
        nodes.push(cell);
      });
      this.gridEl.replaceChildren.apply(this.gridEl, nodes);
      if (api && typeof api.syncAll === 'function') api.syncAll();

      if (this.countEl) this.countEl.textContent = shown.length ? this.countText(shown.length) : '';
      this.setState(shown.length ? 'full' : 'empty');
    }

    setState(state) {
      this.setAttribute('data-state', state);
      if (this.fullEl) this.fullEl.hidden = state !== 'full';
      if (this.emptyEl) this.emptyEl.hidden = state !== 'empty';
      Array.prototype.forEach.call(this.fullOnly || [], function (el) { el.hidden = state !== 'full'; });
    }

    clear() {
      var api = this.api();
      if (api) api.clear();
      if (document.lystiaOverlay) document.lystiaOverlay.close();
      this.refresh();
      var toast = document.lystiaToast;
      var text = this.getAttribute('data-text-cleared');
      if (toast && text) toast.show(text, { icon: 'check' });
    }
  }

  if (window.customElements) customElements.define('lystia-favorites', LystiaFavorites);
})();
